module.exports = __webpack_public_path__ + "static/media/23_tn.f0f4add8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/23_tn.jpg
// module id = 237
// module chunks = 0